import dayjs from 'dayjs'
import { times } from 'lodash'

import { uiMonthNames } from 'src/utils/dateFormat'

/**
 * Month names in the active UI language, index 0 = January. Resolved per call
 * so the words follow the user's language once it is applied (PRO-658).
 */
export const getMonths = (): string[] => uiMonthNames()

/**
 * `{ label, value }` options for the twelve months, `value` 0-based (dayjs).
 *
 * The array identity is stable, but each `label` is a GETTER that resolves the
 * name lazily from the active UI language. This is deliberate and load-bearing:
 * the month names are English until `DayjsI18n` applies the user's locale, and
 * `src/api/consts/months` is pulled in early via the storybook barrel, so a
 * plain `dayjs.months()` array would freeze in English for every month picker
 * in the app (PRO-658). Reading `.label` at render time (which antd `Select`
 * and every `.find(...).label` consumer does) instead yields the current
 * language.
 *
 * DERIVED LISTS MUST PRESERVE THE GETTER. Destructuring `label` at module
 * scope — `monthsLabelMap.map(({ label }) => ...)` — re-freezes it and brings
 * the bug back. Copy the getter across instead (see `MONTH_FILTER_OPTIONS` /
 * `MONTH_OPTIONS`).
 */
export const monthsLabelMap: { readonly label: string; value: number }[] =
  times(12, (value) => ({
    get label() {
      return getMonths()[value]
    },
    value,
  }))

export const monthsDuration = times(12, (i) =>
  // 2024 is set as a leap year to avoid issues with February
  dayjs().year(2024).month(i).daysInMonth()
)
